// Utility functions for parsing and managing artifacts in agent messages

const ARTIFACT_REGEX = /<Artifact\s+filename="([^"]+)"\s+language="([^"]+)"(?:\s+relative_path="([^"]*)")?[^>]*>([\s\S]*?)<\/Artifact>/gi;
export const parseArtifacts = (content, showConsoleMessagesRef) => {
  if (showConsoleMessagesRef?.current) {
    console.log('[parseArtifacts]: Parsing content:', content);
  }
  const artifacts = [];
  let match;
  let processedContent = content;

  // Reset regex lastIndex to ensure proper matching
  ARTIFACT_REGEX.lastIndex = 0;
  while ((match = ARTIFACT_REGEX.exec(content)) !== null) {
    const [fullMatch, filename, language, relativePath, artifactContent] = match;
    const artifact = {
      id: filename,
      // Using filename as ID as requested
      filename,
      language,
      relative_path: relativePath || '',
      content: artifactContent.trim(),
      is_user_edited: false,
      created_at: new Date().toISOString(),
      full_match: fullMatch
    };
    artifacts.push(artifact);

    // Replace the full artifact tag with a placeholder for the button
    processedContent = processedContent.replace(fullMatch, `[ARTIFACT:${filename}]`);
  }
  if (showConsoleMessagesRef?.current) {
    console.log('[parseArtifacts]: Found', artifacts.length, 'artifacts');
    console.log('[parseArtifacts]: Processed content:', processedContent);
  }
  return {
    artifacts,
    processedContent
  };
};
export const extractArtifactFromContent = content => {
  const result = parseArtifacts(content);
  return result.artifacts.length > 0 ? result.artifacts[0] : null;
};
export const hasArtifacts = content => {
  ARTIFACT_REGEX.lastIndex = 0;
  return ARTIFACT_REGEX.test(content);
};
export const createArtifactButton = filename => {
  return {
    type: 'artifact_button',
    filename,
    display_text: filename
  };
};
export const getLanguageFromFilename = filename => {
  const extension = filename.split('.').pop()?.toLowerCase();
  const languageMap = {
    js: 'javascript',
    jsx: 'javascript',
    ts: 'typescript',
    tsx: 'typescript',
    py: 'python',
    html: 'html',
    css: 'css',
    scss: 'scss',
    sass: 'sass',
    json: 'json',
    md: 'markdown',
    yaml: 'yaml',
    yml: 'yaml',
    xml: 'xml',
    php: 'php',
    java: 'java',
    c: 'c',
    cpp: 'cpp',
    cs: 'csharp',
    rb: 'ruby',
    go: 'go',
    rs: 'rust',
    sh: 'shell',
    bash: 'shell',
    sql: 'sql'
  };
  return languageMap[extension] || 'text';
};
export const validateArtifact = artifact => {
  return artifact && typeof artifact.filename === 'string' && typeof artifact.language === 'string' && typeof artifact.content === 'string';
};